import React, { useEffect, useRef, useState } from "react";
import "./Pathway.css";
import { TiTick } from "react-icons/ti";

const Pathway = ({ title, program }) => {
  const sectionRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [activeStep, setActiveStep] = useState(-1);

  console.log(program, "program");
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAnimation();
        }
      },
      { threshold: 0.4 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  const startAnimation = async () => {
    const points = [0, 33.3, 66.6, 100];

    for (let i = 0; i < points.length; i++) {
      setProgress(points[i]); // animate line
      await wait(1000); // wait for line transition
      setActiveStep(i); // THEN activate circle
      await wait(600); // pause before next move
    }
  };

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));

  const animateTo = (target) => {
    return new Promise((resolve) => {
      setProgress(target);
      setTimeout(resolve, 1000); // same as CSS transition
    });
  };

  const pause = (ms) => new Promise((res) => setTimeout(res, ms));

  return (
    <div className="Pathway" ref={sectionRef}>
      <div className="Pathway-box landing-pages">
        <div className="pathway-header">
          <h2 className="chooseus-title">{title}</h2>
        </div>

        <div className="Pathway-content">
          <div className="progress-line-bg"></div>

          <div
            className="progress-line-fill"
            style={{ width: `${progress}%` }}
          ></div>

          {program?.map((step, index) => (
            <div className="pathway-item-box">
              <div
                key={index}
                className={`Pathway-card ${
                  index <= activeStep ? "active" : ""
                }`}
              >
                <div className="circle">
                  {index <= activeStep && <TiTick />}
                </div>
              </div>
              <h3 className="pathway-title">{step.program}</h3>
              <p className="pathway-age">{step.ageRange} Years</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pathway;
